import { AlertCircle } from "react-feather"
import { Button } from "@/components/ui/button"

interface TicketNotificationBarProps {
  message: string
  actionLabel?: string
  onAction?: () => void
}

export function TicketNotificationBar({
  message,
  actionLabel,
  onAction,
}: TicketNotificationBarProps) {
  return (
    <div className="flex items-center justify-between gap-2 px-3 py-3 bg-slate-100 border border-slate-400 rounded-md">
      <div className="flex items-center gap-2 flex-1">
        <AlertCircle className="h-3.5 w-3.5 flex-shrink-0" />
        <span className="text-xs font-semibold">{message}</span>
      </div>
      {actionLabel && onAction && (
        <Button
          variant="link"
          size="sm"
          onClick={onAction}
          className="p-0 h-auto font-bold text-sm"
        >
          {actionLabel}
        </Button>
      )}
    </div>
  )
}
